import { render, staticRenderFns } from "./TicketSettings.vue?vue&type=template&id=6dedebc2&scoped=true"
import script from "./TicketSettings.vue?vue&type=script&lang=js"
export * from "./TicketSettings.vue?vue&type=script&lang=js"
import style0 from "./TicketSettings.vue?vue&type=style&index=0&id=6dedebc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dedebc2",
  null
  
)

export default component.exports